/**
 * @generated SignedSource<<924af389d71f9a9953c850e8001cd20c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemLiveArticleContentArticle$data = {
  readonly entityId: string;
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"articleImageGalleryContent" | "contentSchemaRenderContent" | "contentShareWidgetContent">;
  readonly " $fragmentType": "itemLiveArticleContentArticle";
};
export type itemLiveArticleContentArticle$key = {
  readonly " $data"?: itemLiveArticleContentArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleContentArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemLiveArticleContentArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "950931457e1c101a811bf1c57fed55f7";

export default node;
